import * as ko from 'knockout'
import { BettingInformation } from '@classic/Betting-v2/Model/BettingInformation'
import ObservableRaceKey from '@classic/Betting-v2/Model/Observables/ObservableRaceKey'
import * as EventAggregator from '@classic/AppUtils/Framework/Messaging/EventAggregator'
import Guard from '@classic/AppUtils/Framework/Guard'
import { Disposable } from '@classic/AppUtils/Framework/Disposable/Disposable'

export class FieldViewModel extends Disposable {
  public bettingContext: BettingInformation
  public raceKey: ObservableRaceKey
  public selected: ko.PureComputed<boolean>

  constructor(params: { raceKey: ObservableRaceKey; bettingContext: BettingInformation }) {
    super()
    Guard.notNull(params.bettingContext)
    Guard.notNull(params.raceKey)

    this.bettingContext = params.bettingContext
    this.raceKey = params.raceKey
    this.selected = ko.pureComputed<boolean>(() => {
      if (params.bettingContext.field()[this.raceKey.leg() - 1] !== undefined) {
        const field: boolean = params.bettingContext.field()[this.raceKey.leg() - 1]()
        return field
      }
      return false
    })

    this.registerDisposals(() => {
      this.selected.dispose()
    })
  }

  public toggle(option: unknown, event: Event): void {
    event.preventDefault()
    EventAggregator.publish('field-selected-command', {
      raceNumber: this.raceKey.raceNumber(),
      position: this.raceKey.leg() - 1,
      selected: !this.selected(),
    })
  }
}
